import { FeedbackVideo } from "./FeedbackVideo";
import { FeedbackProtocolReview, FeedbackProtocolReflections } from "./FeedbackProtocol";

export const FeedbackContext = () => (
  <section className="flex min-h-0 flex-col bg-[#0f0f10] text-[#faf9f5] lg:min-h-screen" data-testid="feedback-context-panel">
    <header className="flex h-20 items-center justify-between border-b border-white/15 px-6 md:px-10 lg:px-14" data-testid="feedback-header">
      <a href="/" className="transition-opacity duration-200 hover:opacity-65" data-testid="feedback-logo-link">
        <img src="/assets/feedback/logo-from-source-pdf.png" alt="Vitura" className="w-28 mix-blend-screen" />
      </a>
      <span className="label !text-[8.5px] !text-white/45">Five-day sample / Feedback</span>
    </header>

    <div className="flex flex-1 flex-col px-6 py-12 md:px-10 md:py-14 lg:px-14 lg:py-14">
      <div>
        <div className="sample-accent label !text-[9px]" data-testid="feedback-context-eyebrow">Your experience / In your words</div>
        <h1 className="mt-6 max-w-2xl font-display text-4xl leading-[0.98] sm:text-5xl lg:text-[56px]" data-testid="feedback-page-title">
          Your take shapes<br /><span className="editorial sample-editorial-strong" data-testid="feedback-hero-editorial">what comes next.</span>
        </h1>
        <p className="mt-6 max-w-lg text-[15px] leading-relaxed text-white/70" data-testid="feedback-intro-copy">
          One shot is a taste. Five days is a signal. Tell us what stood out—and what still needs work.
        </p>
      </div>

      <section className="mt-12 border-y border-white/15 py-10" data-testid="feedback-protocol-panel">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-[minmax(0,1.25fr)_minmax(180px,.75fr)] sm:items-end">
          <FeedbackProtocolReview />

          <div className="relative min-h-[360px] overflow-hidden bg-black sm:min-h-[470px]" data-testid="feedback-product-visual">
            <FeedbackVideo
              poster="/assets/feedback/cucumber-melon-spin-poster.jpg"
              className="absolute inset-0 h-full w-full object-cover object-center"
              data-testid="feedback-spinning-bottle-video"
            >
              <source src="/assets/feedback/cucumber-melon-spin.webm" type="video/webm" />
              <source src="/assets/feedback/cucumber-melon-spin.mp4" type="video/mp4" />
            </FeedbackVideo>
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-white mix-blend-difference">
              <div className="label !text-[7.5px]">Cucumber Melon</div>
              <div className="label !text-[7.5px]">2 fl oz / 60 mL</div>
            </div>
          </div>
        </div>
        <FeedbackProtocolReflections />
      </section>

      <div className="mt-auto grid grid-cols-3 pt-8" data-testid="feedback-protocol-summary">
        {[['5', 'Bottles'], ['5', 'Days'], ['1', 'Honest read']].map(([value, label], index) => (
          <div key={label} className={`px-3 first:pl-0 ${index < 2 ? 'border-r border-white/15' : ''}`}>
            <span className="font-display text-xl">{value}</span>
            <span className="ml-2 label !text-[7.5px] !text-white/42">{label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);